var _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCloud(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_4054",
    "data-name": "Group 4054",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 19.242 16.411",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1994",
    "data-name": "Rectangle 1994",
    width: 19.242,
    height: 16.411
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3600",
    "data-name": "Group 3600",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3215",
    "data-name": "Path 3215",
    d: "M7.528,16.411l-.343-3.042H3.331A3.332,3.332,0,0,1,2.507,6.81a4.236,4.236,0,0,1,4.221-3.96c.14,0,.281.007.421.021a4.231,4.231,0,0,1,8.177.65A4.249,4.249,0,0,1,17.269,7a3.331,3.331,0,0,1-1.358,6.373H11.494Zm-.8-12.817A3.489,3.489,0,0,0,3.244,7.079l0,.354-.317.05a2.586,2.586,0,0,0,.4,5.141H7.851l.27,2.393,3.12-2.393h4.67A2.586,2.586,0,0,0,16.77,7.6l-.26-.092.012-.276c0-.055,0-.1,0-.152a3.5,3.5,0,0,0-1.73-3.011l-.159-.093-.023-.183a3.485,3.485,0,0,0-6.836-.418l-.085.337-.342-.062a3.521,3.521,0,0,0-.621-.055"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloud);
export default __webpack_public_path__ + "static/media/Cloud.46d23dda.svg";
export { ForwardRef as ReactComponent };